
























































































































import { User } from "@/api/modules/user"
import { TTStore } from "@/store"
import { timeago } from "@/utils/base"
import { Component, Prop, Vue, Watch } from "vue-property-decorator"

interface IPreset {
  tstore: TTStore
}

interface IData {
  brief: string
  communityId: string
  icon: string
  id: string
  title: string
  type: string
}

@Component({
  name: "answerDialog",
  components: {
    NoMoreData: () => import("@/components/noMoreData/noMore.vue")
  }
})
export default class answerDialog extends Vue {
  timeago = timeago
  // 通用弹窗的JS数据和方法
  cancel() {
    this.isSubmit = false
    this.dialogVisible = false
  }

  onSubmit() {
    this.isSubmit = true
    this.dialogVisible = false
  }

  dialogDataPresets: IPreset = {
    tstore: null
  }

  isRender: boolean = true
  isSubmit: boolean = false

  @Prop()
  dialogVisible: boolean = false

  get userInfo() {
    return this.dialogDataPresets.tstore.modules.userInfo.getters.userInfo
  }

  get api() {
    return this.dialogDataPresets.tstore.state.api
  }

  type = 0
  onTypeChange() {
    if (this.fList.length === 0) {
      this.getFList()
    }
  }

  myList: User.IHistoriesAnswer[] = []
  fList: User.IAnswerCollection[] = []

  async getMyList() {
    const res = await this.api.user.myAnswers(this.userInfo._id)
    this.myList = res.data
  }

  async getFList() {
    const res = await this.api.user.answerCollections(this.userInfo._id)
    this.fList = res.data
  }
  selected: IData = null
  handleSelect(item: User.IHistoriesAnswer | User.IAnswerCollection) {
    this.selected = {
      brief: item.brief,
      communityId: "", // 只有帖子传了
      icon:
        "http://static-web.ghzs.com/website-static/images/icon_new_reply.png",
      id: item._id,
      title: item.question.title,
      type: "answer"
    }
    this.onSubmit()
  }

  @Watch("dialogVisible")
  onShow(c) {
    if (c) {
      this.getMyList()
    }
  }
}
